import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { createOffering } from '../api/offerings';
import type { OfferingFormValues } from '../types';
import { notification } from 'antd';

export function useCreateOffering(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OfferingFormValues) => createOffering(data),
    onSuccess: () => {
      notification.success({ message: 'Offering created successfully' });
      invalidateListResource(queryClient, 'offerings');
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to create offering' });
    },
  });
}
